var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"editor",attrs:{"id":"editor-event","contenteditable":"true","spellcheck":"false"},on:{"input":_vm.onInput,"keydown":_vm.onKeyDown,"keyup":_vm.onKeyUp,"click":_vm.onClick,"blur":_vm.onBlur,"paste":_vm.onPaste}})}
var staticRenderFns = []

export { render, staticRenderFns }